export default "/images/default-dashboard-cover.png?8d1a61ba5a68327f29eb6aa85b3b3098";